
























import { Component, Vue } from 'vue-property-decorator';

import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

import MmicLossHistoryReportList from '@/components/Reports/MmicLossHistoryReportList.vue';

import Reports, { ReportsMetadata, ReportPacket } from '@/services/Reports';
import Policy from '@/services/Policy';
import Alert from '@/components/Global/Alert.vue';
import { Getter } from 'vuex-class';
import store from '@/store/index';

import * as Sentry from '@sentry/browser';

@Component({
	name: 'LossHistoryReports',
	components: {
		Welcome,
		Loading,
		MmicLossHistoryReportList,
		Sidebar,
		Alert,
	},
})
export default class LossHistoryReports extends Vue {
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private policies: any;
	private error: boolean = false;
	private loading: boolean = true;
	private reports: any[];
	private headingDescription: string = `
		<i
               class="fas fa-file-alt fa-5x d-none d-md-block float-left"
               style="color: #1F98BE;margin-bottom: 30px;margin-right:30px"
          ></i>
		<p class="pt-md-4">
			You can access your loss history reports by choosing a policy from the policy list below.
		</p><div style="clear:both;"></div>`;

	private async created() {
		try {
			const policyNumbers: string[] | undefined = Array.isArray(this.policies)
				? this.policies.map(policy => policy.policy_number)
				: undefined;
			if (!policyNumbers) {
				throw new Error('There are no policy numbers associated with the current user');
			}

			const promises: Array<Promise<any>> = policyNumbers.map(Reports.getLossHistoryReports);
			const allReports: ReportPacket[] = [];
			for (const promise of promises) {
				try {
					const reportPacket: ReportPacket = await promise;
					allReports.push(reportPacket);
				} catch (error) {
					// Sentry.captureException(error);
				}
			}
			if (allReports.length === 0) {
				throw new Error('No Reports were successfully fetched');
			}
			// Convert into an array of ReportsPackets.
			this.reports = allReports;
		} catch (error) {
			// Sentry.captureException(error);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
